import React from "react";
import { useAuth } from "../Auth/AuthContext";
import { Navigate } from "react-router-dom";
import MarketingPage from "./MarketingPage";

const Home = () => {
  const { currentUser } = useAuth();

  if (currentUser) {
    return <Navigate to="/deeds" replace />;
  }

  return <MarketingPage />;
};

export default Home;
